import { SSO_LOGIN_URL } from '../Config/env';

export const redirectToLogin = source => {
  const redirect = encodeURIComponent(`${window.location.origin}/login-check`);
  const sourceParam = source ? `&source=${source}` : '';
  window.location.href = `${SSO_LOGIN_URL}?redirect=${redirect}${sourceParam}`;
};
